/**
 * Valid benefit field names for FML LOC
 *
 * Used to filter out fields that don't belong to FML benefits when saving to API.
 * These fields represent the API structure (nested objects created by transforms).
 */

export const FML_VALID_FIELDS = new Set([
  "objectType",
  // Nested benefit objects (created by transform, not flat grid fields)
  "federalFmla",
  "unpaidStateLeaves",
  "militaryUserra",
  "juryDuty",
  "ada",
  // Simple fields (not nested)
  "integratedStdFmlaClaimIntake",
  "historyAndTakeover",
  "companyLeaves",
  "correspondence",
]);
